module.exports = __webpack_public_path__ + "static/media/dashboard.8b4370ef.png";